import {
  SCHEDULER_CLEAR,
  SCHEDULER_CLEAR_SCHEDULE_HISTORY,
  SCHEDULER_LOAD_SCHEDULE_HISTORY,
  SCHEDULER_LOAD_SCREENSHOT,
  SCHEDULER_SELECT_SCREENSHOT,
  SCHEDULER_TOGGLE_SCREENSHOT_MODAL,
} from '../../actionTypes/scheduler';
import produce from 'immer';
import { SortingKindEnum } from '../../../utils/interfaces';
import {
  IScheduleHistoryQuery,
  Order,
} from '../../../utils/apollo/graphqlSchema';
import { PayloadFromCreator } from '../../utils/types';
import {
  loadCurrentHistoryAction,
  loadScreenshotAction,
  selectScreenshotAction,
  toggleScreenshotModalAction,
} from '../../actions/scheduler';

export interface IScheduler {
  schedules: any[];
  isExecutionHistoryOpen: boolean;
  isScreenshotModalOpen: boolean;
  screenshotSelectedImage: number | null;
  loadedScreenshots: Record<string, boolean> | null;
  sorting: {
    enabled: boolean;
    kind: SortingKindEnum;
    type: Order;
  };
  currentSchedule: any;
  currentHistory: IScheduleHistoryQuery['scheduleHistory'] | null;
}

const defaultState: IScheduler = {
  schedules: [],
  isExecutionHistoryOpen: false,
  isScreenshotModalOpen: false,
  screenshotSelectedImage: null,
  loadedScreenshots: null,
  sorting: {
    enabled: false,
    kind: SortingKindEnum.NAME,
    type: Order.Asc,
  },
  currentSchedule: null,
  currentHistory: null,
};

export default (state = defaultState, action: any) =>
  produce(state, (draft: any) => {
    switch (action.type) {
      case SCHEDULER_CLEAR: {
        return defaultState;
      }
      case SCHEDULER_LOAD_SCHEDULE_HISTORY: {
        const scheduleHistory = action.payload as PayloadFromCreator<
          typeof loadCurrentHistoryAction
        >;
        draft.currentHistory = scheduleHistory;
        return;
      }
      case SCHEDULER_CLEAR_SCHEDULE_HISTORY: {
        draft.currentHistory = null;
        return;
      }
      case SCHEDULER_TOGGLE_SCREENSHOT_MODAL: {
        const modalState = action.payload as PayloadFromCreator<
          typeof toggleScreenshotModalAction
        >;
        draft.isScreenshotModalOpen = modalState;
        return;
      }
      case SCHEDULER_SELECT_SCREENSHOT: {
        const screenshotIndex = action.payload as PayloadFromCreator<
          typeof selectScreenshotAction
        >;
        draft.screenshotSelectedImage = screenshotIndex;
        return;
      }
      case SCHEDULER_LOAD_SCREENSHOT: {
        const screenshotUrl = action.payload as PayloadFromCreator<
          typeof loadScreenshotAction
        >;
        draft.loadedScreenshots = {
          ...state.loadedScreenshots,
          [screenshotUrl]: true,
        };
        return;
      }
    }
  });
